/**
 * Floodlight design system (Plans, Community, Optimizer, /why). See theme.js
 * for the tokens and floodlightCss.js for the hover system.
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FL, label, ACCENT_GRADIENT } from './theme';
import { IS_WEB } from '../../utils/motion';

export { FL, FL_PALETTES, FONT, display, label, body, nums, gutter, flThemeCss, glass, ACCENT_GRADIENT } from './theme';
export { FL_THEME_KEY, getFlTheme, setFlTheme, useFlTheme } from './flTheme';
export { ensureFloodlight, FLOODLIGHT_CSS } from './floodlightCss';
export { default as FLButton } from './FLButton';
export { default as FLHeadline } from './FLHeadline';
export { default as FLMarquee } from './FLMarquee';
export { default as FLPage } from './FLPage';

/** Section kicker: a light-purple index, a short accent hairline and a spaced caps label. "01 —— PLANS" */
export function FLKicker({ index, children, tone = 'ink', style }) {
    const color = tone === 'paper' ? FL.stageSoft : FL.ink2;
    return (
        <View style={[styles.kicker, style]}>
            {index != null && <Text style={[label(12), styles.kickerText, { color: tone === 'paper' ? FL.greenOnInk : FL.greenInk }]}>{String(index).padStart(2, '0')}</Text>}
            <View style={[styles.kickerRule, IS_WEB ? { backgroundImage: ACCENT_GRADIENT } : { backgroundColor: FL.green }]} />
            <Text style={[label(12), styles.kickerText, { color }]}>{children}</Text>
        </View>
    );
}

/** A full-width hairline (the divider between rows and sections). */
export function FLRule({ style, color = FL.rule, weight = 1 }) {
    return <View style={[{ height: weight, backgroundColor: color, alignSelf: 'stretch' }, style]} />;
}

const styles = StyleSheet.create({
    kicker: { flexDirection: 'row', alignItems: 'center', gap: 12 },
    kickerRule: { width: 28, height: 1, borderRadius: 1 },
    kickerText: { letterSpacing: 2.2 },
});
